//App.js
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useEffect } from "react";

import HomePublic from "./pages/public/HomePublic";
import FundraiserPublic from "./pages/public/FundraiserPublic";
import FundraiserLevelPublic from "./pages/public/FundraiserLevelPublic";
import DonationPoolPublic from "./pages/public/DonationPoolPublic";
import UnsubscribePage from "./pages/public/UnsubscribePage";
import NotFound from "./pages/public/NotFound";
import RentPublic from "./pages/public/RentPublic";

import DynamicPublicPage from "./pages/public/DynamicPublicPage";
import DynamicMemberPage from "./pages/DynamicMemberPage";

import Directory from "./pages/Directory";
import Events from "./pages/Events";
import Home from "./pages/Home";
import Committees from "./pages/Committees";
import ExecutiveBoard from "./pages/ExecutiveBoard";
import MyAccount from "./pages/MyAccount";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import { LoginForm } from "./components/LoginForm";
import { RegisterForm } from "./components/RegisterForm";
import { MembersLayout } from "./components/MembersLayout";
import { PublicLayout } from "./components/public/PublicLayout";
import { ScrollToTop } from "./components/ScrollToTop";

import { useAuth } from "./components/AuthContext";
import { applyPrimaryColor } from "./config";

function App() {
  const { isAuthenticated, isInitializing } = useAuth();

  useEffect(() => {
    // Apply primary color on app load
    applyPrimaryColor();
  }, []);

  // Show loading screen while authentication is being initialized
  if (isInitializing) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: "'Montserrat', sans-serif"
      }}>
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // console.log('🔍 DEBUGGING ENVIRONMENT:');
  // console.log('API_URL:', process.env.REACT_APP_API_URL);
  // console.log('API_BASE_URL:', process.env.REACT_APP_API_BASE_URL);
  // console.log('DEMO_MODE:', process.env.REACT_APP_DEMO_MODE);
  // console.log('All REACT_APP vars:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP')));

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Public site */}
        <Route path="/" element={<PublicLayout />}>
          <Route index element={<HomePublic />} />
          <Route path="rent" element={<RentPublic />} />
          <Route path="*" element={<DynamicPublicPage />} />
        </Route>

        {/* Other public-facing pages */}
        <Route path="/fundraisers/:fid" element={<FundraiserPublic />} />
        <Route path="/fundraisers/:fid/:pid" element={<FundraiserLevelPublic />} />
        <Route path="/donate/:pid" element={<DonationPoolPublic />} />
        <Route path="/unsubscribe" element={<UnsubscribePage />} />

        {/* Admin route (Firebase protected separately) */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Admin />} />

        {/* Registration route (public) */}
        <Route path="/register" element={<RegisterForm />} />

        {/* Members-only section */}
        <Route
          path="/members/*"
          element={
            isAuthenticated ? (
              <MembersLayout />
            ) : (
              <LoginForm />
            )
          }
        >
          <Route index element={<Navigate to="home" />} />
          <Route path="home" element={<Home />} />
          <Route path="account" element={<MyAccount />} />
          <Route path="directory" element={<Directory />} />
          <Route path="committees" element={<Committees />} />
          <Route path="executive-board" element={<ExecutiveBoard />} />
          <Route path="events" element={<Events />} />
          <Route path="*" element={<DynamicMemberPage />} />
        </Route>

        {/* Default fallback */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
